'use client';

import { useMediaQueries } from '@repo/cc-ds';

import { AppHeaderNavDefault } from './app-header-nav-default';
import { AppHeaderNavSmUp } from './app-header-nav-sm-up';

export type NavLink = {
  children?: NavLink[];
  isActive?: boolean;
  isDisabled?: boolean;
  label: string;
  onClick?: () => void;
};

interface AppHeaderNavProps {
  navLinks: NavLink[];
  testId?: string;
}

export const AppHeaderNav = (props: Readonly<AppHeaderNavProps>) => {
  const { navLinks, testId } = props;

  const mediaQuery = useMediaQueries();

  return mediaQuery.sm ? (
    <AppHeaderNavSmUp
      navLinks={navLinks}
      testId={testId}
    />
  ) : (
    <AppHeaderNavDefault
      navLinks={navLinks}
      testId={testId}
    />
  );
};
